import React, { useEffect, useRef, useState } from "react";
import { FilterContext } from "../index";
import AttributeItem from "../attributeitem";
import { Button, Typography, Tooltip, Autocomplete, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Skeleton from "@mui/material/Skeleton";
import { Box } from "@material-ui/core";
import { AllAccountsFilterIcon } from "../../SVGs/allAccountsFilterIcon";
import { NetNewFilterIcon } from "../../SVGs/netNewFilterIcon";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { makeStyles } from "@material-ui/core/styles";
import "./index.css";

function AttributeList(props) {
  const divRef = useRef(null);

  const {
    attributeList,
    // getFilterData,
    icp,
    onFilterChange,
    deleteFilter,
    onAddFilterItem,
    // onOrFilterItem,
    // onFilterChange,
    tenantConfigMapper,
    contTenantConfigMapper,
    subfiltersConfig,
    screen,
    tenantId,
  } = React.useContext(FilterContext);
  console.log("props is in attributelist ", props);
  console.log("attributelist1223", attributeList);
  console.log("cheacked 2", attributeList[0]?.isValid);
  const [crmSource, setCRMSource] = useState();
  const [isNetNewEnabled, setIsNetNewEnabled] = useState();
  const [selectedAudience, setSelectedAudience] = useState(
    attributeList[0].attribute === "is_net_new"
      ? attributeList[0]
      : {
          label: "All Accounts",
          value: "all",
          icon: AllAccountsFilterIcon,
        }
  );

  const TargetAudienceOptions = [
    {
      label: "All Accounts",
      value: "all",
      icon: AllAccountsFilterIcon,
    },
    {
      label: "Target - CRM",
      value: "crm",
      icon: () => <img src={`${window._env_.B2_INTENT_SETTING}/logos/${crmSource ? crmSource?.toString().toLowerCase() : ""}.png`} alt="" style={{ width: "18px" }} />,
    },
    {
      label: "Target - Net New",
      value: "net_new",
      icon: NetNewFilterIcon,
    },
  ];

  const getCRMSource = async () => {
    if (crmSource) return;
    const requestBody = {
      tenantId: tenantId,
      tool: "CDP",
      keys: ["CRM"],
    };
    fetch(`${window._env_.TENANT_CONFIG}/tenant/get-tenant-config`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
      credentials: "include",
    })
      .then((response) => response.json())
      .then((response) => {
        try {
          if (response[0].configVal) {
            if (response[0].configVal === "ms dynamics") {
              return setCRMSource("dynamics");
            }
            setCRMSource(response[0].configVal);
          }
        } catch (e) {
          console.log(e);
        }
      });
  };

  const checkNetNewEnabled = async () => {
    if (isNetNewEnabled) return;
    const requestBody = {
      tenantId: tenantId,
      tool: "netNewHub",
      keys: ["isEnabled"],
    };
    const response = await fetch(`${window._env_.TENANT_CONFIG}/tenant/get-tenant-config`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
      credentials: "include",
    });
    const result = await response.json();
    if (result.length > 0) {
      if (result[0].configVal === "true" || result[0].configVal === true) {
        return setIsNetNewEnabled(true);
      } else return setIsNetNewEnabled(false);
    }
  }

  useEffect(() => {
    getCRMSource();
    checkNetNewEnabled();
  }, []);

  const useStyles = makeStyles({
    customTextField: {
      "& input::placeholder": {
        fontSize: "12px",
        fontFamily: "Inter",
        alignItems: "center",
      },
    },
  });
  const classes = useStyles();

  const isSubfilterAvailable = (index) => {
    const restSubfilterArr = fetchAttributeArr(`${index}-`, true);

    if (restSubfilterArr?.length > 0) {
      return true;
    }
    return false;
  };

  if (!tenantConfigMapper || tenantConfigMapper?.size === 0) {
    return (
      <div style={{ display: "grid", gap: "10px" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "180px 180px 1fr",
            gap: "10px",
          }}
        >
          <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
          <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
          <Skeleton variant="text" sx={{ fontSize: "3rem" }} />
        </div>
        <Skeleton variant="rounded" sx={{ height: "32px", width: "64px", borderRadius: "18px" }} />
      </div>
    );
  }

  function calculateSubfilterAttributeArray(values, source = false, activityType = false) {
    try {
      const finalSubfilterAttribute = Array.isArray(values) ? values : [];

      if (screen === "isAccountHub" || screen === "isOpportunityHub") {
        return finalSubfilterAttribute
          .map((key) => {
            if (source) {
              if (tenantConfigMapper.get(key)) {
                const obj = {
                  ...tenantConfigMapper.get(key),
                  attribute: key,
                  logo: source,
                  activityType: activityType,
                };
                return obj;
              }
              return false;
            } else if (tenantConfigMapper.get(key)) {
              return { ...tenantConfigMapper.get(key), attribute: key };
            }
          })
          .filter((obj) => obj);
      } else if (props.exportType === "CONTACT") {
        return finalSubfilterAttribute
          .map((key) => {
            if (source) {
              if (contTenantConfigMapper.get(key)) {
                const obj = {
                  ...contTenantConfigMapper.get(key),
                  attribute: key,
                  logo: source,
                  activityType: activityType,
                };
                return obj;
              }
              return false;
            } else if (contTenantConfigMapper.get(key)) {
              return { ...contTenantConfigMapper.get(key), attribute: key };
            }
          })
          .filter((obj) => obj);
      }

      return [];
    } catch (e) {
      console.error("Error occurred while calculating subfilter array", e);
      return [];
    }
  }

  const fetchAttributeArr = (elementIndex, subfilter) => {
    if (subfilter) {
      const parentFilter = attributeList[+elementIndex.split("-")[0]] ?? [];
      const subfilterArr = parentFilter?.subfilter;

      const { attribute, source, values: parentFilterValues } = parentFilter;

      const configObject = subfiltersConfig?.[attribute] || [];

      const resultArray = [];
      /* if extra field added */
      if (configObject?.extrafields) {
        const subfilterAttrArray = configObject.extrafields;
        resultArray.push(...calculateSubfilterAttributeArray(subfilterAttrArray));
      }
      parentFilterValues.map((currentValue) => {
        const subfilterAttrArray = configObject?.[currentValue?.source]?.[currentValue?.activityType];
        resultArray.push(...calculateSubfilterAttributeArray(subfilterAttrArray, currentValue?.source, currentValue?.activityType));
      });

      return resultArray.filter((obj) => !subfilterArr?.find((currObj) => currObj.attribute === obj.attribute && currObj.logo === obj.logo));
    }

    if (screen === "isAccountHub" || screen === "isOpportunityHub") {
      return Array.from(tenantConfigMapper, ([key, value]) => ({
        ...value,
        attribute: key,
      }))
        .filter((obj) => obj?.isFilter)
        .sort((a, b) => {
          if (a.groupLabel === b.groupLabel) {
            return a.label < b.label ? -1 : 1;
          } else {
            return a.groupLabel < b.groupLabel ? -1 : 1;
          }
        });
    } else if (screen === "isContactHub") {
      return Array.from(contTenantConfigMapper, ([key, value]) => ({
        ...value,
        attribute: key,
      }))
        .filter((obj) => obj?.isFilter)
        .sort((a, b) => {
          if (a.groupLabel === b.groupLabel) {
            return a.label < b.label ? -1 : 1;
          } else {
            return a.groupLabel < b.groupLabel ? -1 : 1;
          }
        });
    }

    return [];
  };

  function isSubfilterTrue(filterAttribute) {
    let isTrue = false;
    if (filterAttribute.values?.length > 0) {
      for (const itr of filterAttribute.values) {
        const { source, activityType } = itr;
        if (subfiltersConfig?.[filterAttribute?.attribute]?.[source]?.[activityType]) {
          isTrue = true;
          break;
        }
      }
    }
    if (!isTrue && ["includes", "excludes"].includes(filterAttribute?.relation) && subfiltersConfig?.[filterAttribute?.attribute]?.extrafields) {
      isTrue = true;
    }
    return (
      filterAttribute?.isValid &&
      (filterAttribute.subfilter === undefined || (filterAttribute.subfilter?.length === 0 ? true : filterAttribute.subfilter?.[filterAttribute.subfilter?.length - 1]?.isValid)) &&
      isTrue
    );
  }

  return (
    <div>
      {(isNetNewEnabled || props.new_new_permission) && <div style={{ marginTop: "16px", display: "flex", flexDirection: "column", gap: "8px", marginBottom: "24px" }}>
        <Typography
          variant="subtitle2"
          className="and-button1"
          style={{
            width: "180px",
            height: "24px",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "14px",
            lineHeight: "100%",
            alignItems: "center",
            letterSpacing: "0.15px",
            textTransform: "none",
            color: "#424242",
          }}
        >
          Target Audience
        </Typography>
        <Autocomplete
          sx={{ width: "330px" }}
          options={TargetAudienceOptions}
          getOptionLabel={(option) => (option?.values?.[0] === true || option.value ==="net_new" ? 'Target - Net New' : option?.values?.[0] === false || option.value === 'crm' ? 'Target - CRM' : 'All Accounts')}
          // open
          value={selectedAudience}
          onChange={(e, newValue) => {
            // const index = newValue.value === "net_new" ? 2 : newValue.value === "crm" ? 1 : 0;
            const netNewFilterObj = {
              // label: TargetAudienceOptions[index].label,
              attribute: "is_net_new",
              relation: "is",
              type: "accounts",
              values: [newValue.value === "net_new"],
            };
            if (newValue.value === "net_new" || newValue.value === "crm") {
              onFilterChange({ attrData: netNewFilterObj, elementIndex: 0 });
            } else if (attributeList[0].attribute === "is_net_new") {
              deleteFilter(0);
            }
            setSelectedAudience(newValue);
          }}
          disableClearable
          popupIcon={<KeyboardArrowDownRoundedIcon />}
          renderOption={(props, option) => {
            const Icon = option.icon;
            return (
              <li {...props}>
                <Box display="flex" alignItems="center" fontSize="12px" fontWeight={500} color="#424242" fontFamily={"Inter"}>
                  <Icon />
                  <Box ml={1}>{option.label}</Box>
                </Box>
              </li>
            );
          }}
          renderInput={(params, p2) => {
            const index = params.inputProps.value === "Target - CRM" ? 1 : params.inputProps.value === "Target - Net New" ? 2 : 0;
            const SelectedIcon = TargetAudienceOptions[index].icon;
            return (
              <TextField
                {...params}
                placeholder="Select Audience"
                classes={{ root: classes.customTextField }}
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: SelectedIcon ? <SelectedIcon /> : null,
                  sx: {
                    input: {
                      fontWeight: 500,
                      fontSize: "12px",
                      color: "#424242",
                      height: "5px",
                    },
                  },
                }}
              />
            );
          }}
        />
      </div>}
      <div className="scroll" style={{ overflowX: "hidden", maxHeight: "50vh" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "12px",
            marginBottom: "8px",
            color: "#595959",
            gap: "12px",
          }}
        >
          <Typography
            variant="subtitle2"
            style={{
              width: "180px",
              height: "24px",
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "24px",
              display: "flex",
              alignItems: "center",
              letterSpacing: "0.15px",
              textTransform: "none",
              color: "#424242",
              flex: "none",
              order: "0",
              flexGrow: "0",
            }}
          >
            Attribute
          </Typography>
          <Typography
            variant="subtitle2"
            style={{
              width: "180px",
              height: "24px",
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "24px",
              display: "flex",
              alignItems: "center",
              letterSpacing: "0.15px",
              textTransform: "none",
              color: "#424242",
              flex: "none",
              order: 1,
              flexGrow: 0,
            }}
          >
            Relation
          </Typography>
          <Typography
            variant="subtitle2"
            style={{
              width: "280px",
              height: "24px",
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "24px",
              display: "flex",
              alignItems: "center",
              textTransform: "none",
              color: "#424242",
              flex: "none",
              order: 2,
              flexGrow: 1,
            }}
          >
            Values
          </Typography>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {attributeList?.map((attribute, index) => (
              attribute?.attribute !== "is_net_new" && 
            <>
              <div key={attribute?.id} style={{ marginBottom: "0", display: "flex" }}>
                <AttributeItem attributeData={attribute} elementIndex={index} key={index} icp={icp} fetchAttributeArr={fetchAttributeArr} />
              </div>
              {attribute?.subfilter &&
                attribute.subfilter?.length > 0 &&
                attribute.subfilter.map((subfilterAttribute, subfilterIndex) => (
                  <div key={subfilterAttribute?.id} style={{ marginBottom: "8px", display: "flex" }}>
                    <AttributeItem
                      attributeData={subfilterAttribute}
                      elementIndex={`${index}-${subfilterIndex}`}
                      key={`${index}-${subfilterIndex}`}
                      icp={icp}
                      subfilter={true}
                      fetchAttributeArr={fetchAttributeArr}
                    />
                  </div>
                ))}
              {subfiltersConfig?.[attribute?.attribute] && isSubfilterAvailable(index) ? (
                <>
                  {isSubfilterTrue(attribute) ? (
                    <button
                      onClick={() => {
                        onAddFilterItem(attribute, index, true);
                      }}
                      className="subfilterButton"
                    >
                      <AddIcon />
                      <div>Add Sub-Attribute</div>
                    </button>
                  ) : (
                    <Tooltip title={"You can't add sub-filter yet. Fill the values above and try again."}>
                      <button disabled className="subfilterButton">
                        <AddIcon />
                        <div>Add Sub-Attribute</div>
                      </button>
                    </Tooltip>
                  )}
                </>
              ) : (
                <>
                  <div className="subfilterButton"></div>
                </>
              )}
              {(attribute?.filterName && index === attributeList.length - 1) ||
              (attribute?.isValid &&
                index === attributeList.length - 1 &&
                (attribute.subfilter === undefined || attribute.subfilter?.length === 0 ? true : attribute.subfilter?.[attribute.subfilter?.length - 1]?.isValid)) ? (
                <Button
                  color="primary"
                  variant="contained"
                  className="and-button and-button1"
                  ref={divRef}
                  onClick={() => {
                    onAddFilterItem(attributeList[attributeList.length - 1], attributeList.length - 1);
                  }}
                >
                  AND
                </Button>
              ) : (
                <>
                  {index < attributeList.length - 1 ? (
                    <Button
                      className="and-button1"
                      color="primary"
                      variant="contained"
                      ref={divRef}
                      disabled
                      style={{
                        background: "white",
                        color: "#00A75E",
                        border: "1px solid #00A75E",
                        height: "32px",
                        width: "54px",
                        fontSize: "13px",
                        fontWeight: 600,
                        borderRadius: "4px",
                      }}
                    >
                      AND
                    </Button>
                  ) : (
                    <Button
                      className="and-button1"
                      color="primary"
                      variant="contained"
                      ref={divRef}
                      disabled
                      style={{
                        background: "white",
                        color: "#00A75E",
                        border: "1px solid #00A75E",
                        height: "32px",
                        width: "54px",
                        fontSize: "13px",
                        fontWeight: 600,
                        borderRadius: "4px",
                      }}
                    >
                      AND
                    </Button>
                  )}
                </>
              )}
            </>
          ))}
        </div>
      </div>
    </div>
  );
}

export default React.memo(AttributeList);
